import { ADMIN_ROLES } from './system';
import {
  Coin,
  Home2,
  Home3,
  Setting2,
  Judge,
  Bag,
  PercentageSquare,
  Category,
  Gift,
  Flashy,
  Notification,
  Crown,
  Star,
  MoneyRecive,
  Wallet,
  ShieldCross,
  ReceiptItem,
  People,
  Medal,
  TrendUp,
  Star1,
  ChartSquare,
  Truck,
  Activity,
  Briefcase,
  Dislike,
  NoteText,
  Icon,
  Profile2User,
} from 'iconsax-react';

export interface RouteAuthConfig {
  requiredRoles?: string[];
  requiredPermissions?: string[];
  requireAllPermissions?: boolean;
}

export interface RouteMenuItem {
  key: string;
  icon?: Icon;
  labelKey: string;
  auth?: RouteAuthConfig;
  children?: RouteMenuItem[];
  hiddenInMenu?: boolean;
  type?: 'group' | string;
}

export const ROUTE_CONFIG: RouteMenuItem[] = [
  {
    key: '/',
    icon: Home2,
    labelKey: 'home.home',
    auth: {
      requiredRoles: [
        ADMIN_ROLES.superAdmin,
        ADMIN_ROLES.admin,
        ADMIN_ROLES.operationMember,
      ],
      requiredPermissions: ['BUSINESS_OPERATION_READ'],
      requireAllPermissions: true,
    },
  },
  {
    key: '/sellers',
    icon: People,
    labelKey: 'home.sellers-of-yad',
    auth: {
      requiredRoles: [
        ADMIN_ROLES.superAdmin,
        ADMIN_ROLES.admin,
        ADMIN_ROLES.operationMember,
      ],
    },
  },
  {
    key: '/products',
    icon: Bag,
    labelKey: 'home.all-products',
    auth: {
      requiredRoles: [
        ADMIN_ROLES.superAdmin,
        ADMIN_ROLES.admin,
        ADMIN_ROLES.operationMember,
      ],
      requiredPermissions: ['OPERATOR_PRODUCT_READ'],
      requireAllPermissions: true,
    },
  },

  // {
  //   key: '/members',
  //   icon: Profile2User,
  //   labelKey: 'home.members',
  //   auth: {
  //     requiredRoles: [ADMIN_ROLES.superAdmin, ADMIN_ROLES.admin],
  //     requiredPermissions: ['ADMIN_MEMBER_LIST_READ'],
  //   },
  // },
  // {
  //   key: '/dispute',
  //   icon: Profile2User,
  //   labelKey: 'home.dispute',
  //   auth: {
  //     requiredRoles: [
  //       ADMIN_ROLES.superAdmin,
  //       ADMIN_ROLES.admin,
  //       ADMIN_ROLES.disputeMember,
  //     ],
  //     requiredPermissions: ['JOB_DISPUTE_ES_READ'],
  //   },
  // },

  {
    key: '/reviews',
    icon: Star1,
    labelKey: 'home.reviews-reports',
    auth: {
      requiredRoles: [
        ADMIN_ROLES.superAdmin,
        ADMIN_ROLES.admin,
        ADMIN_ROLES.operationMember,
      ],
      requiredPermissions: ['JOB_FEEDBACK_OPERATOR_READ'],
    },
  },

  // {
  //   key: '/commission',
  //   icon: Profile2User,
  //   labelKey: 'home.commission',
  //   auth: {
  //     requiredRoles: [
  //       ADMIN_ROLES.superAdmin,
  //       ADMIN_ROLES.admin,
  //       ADMIN_ROLES.financialMember,
  //     ],
  //     requiredPermissions: ['ADMIN_COMMISSION_CONFIGURATION_READ'],
  //   },
  // },
  // {
  //   key: '/customer-kpis',
  //   icon: Profile2User,
  //   labelKey: 'home.customer-kpis',
  //   auth: {
  //     requiredRoles: [
  //       ADMIN_ROLES.superAdmin,
  //       ADMIN_ROLES.admin,
  //       ADMIN_ROLES.operationMember,
  //     ],
  //   },
  // },
  // {
  //   key: '/customer-kpis/:id',
  //   labelKey: 'home.customer-kpis',
  //   auth: {
  //     requiredRoles: [
  //       ADMIN_ROLES.superAdmin,
  //       ADMIN_ROLES.admin,
  //       ADMIN_ROLES.operationMember,
  //     ],
  //     requiredPermissions: [''],
  //   },
  //   hiddenInMenu: true,
  // },
  // {
  //   key: '/jobs-management',
  //   icon: Profile2User,
  //   labelKey: 'home.jobs-management',
  //   auth: {
  //     requiredRoles: [
  //       ADMIN_ROLES.superAdmin,
  //       ADMIN_ROLES.admin,
  //       ADMIN_ROLES.operationMember,
  //     ],
  //     // requiredPermissions: ['JOB_MANAGEMENT_READ'],
  //   },
  // },
  {
    key: '/support-tickets',
    icon: Profile2User,
    labelKey: 'home.support-tickets',
    auth: {
      requiredRoles: [
        ADMIN_ROLES.superAdmin,
        ADMIN_ROLES.admin,
        ADMIN_ROLES.supportMember,
      ],
      requiredPermissions: ['SUPPORT_TICKET_READ'],
    },
  },
  // {
  //   key: 'reports',
  //   icon: StatusUp,
  //   labelKey: 'home.reports',
  //   children: [
  //     {
  //       key: '/reports/user-reports',
  //       labelKey: 'home.user-reports',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.operationMember,
  //         ],
  //         requiredPermissions: ['USER_REPORT_LIST_READ'],
  //       },
  //     },
  //     {
  //       key: '/reports/jobs-statistics',
  //       labelKey: 'home.jobs-statistics',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.financialMember,
  //           ADMIN_ROLES.operationMember,
  //         ],
  //         requiredPermissions: ['JOB_STATISTICS_REPORT_LIST_READ'],
  //       },
  //     },
  //     {
  //       key: '/reports/commission-reports',
  //       labelKey: 'home.commission-reports',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.financialMember,
  //         ],
  //         requiredPermissions: ['COMMISSION_REPORT_LIST_READ'],
  //       },
  //     },
  //     {
  //       key: '/reports/purchased-coins-reports',
  //       labelKey: 'home.purchased-coins',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.financialMember,
  //         ],
  //         requiredPermissions: ['PURCHASED_COINS_REPORT_LIST_READ'],
  //       },
  //     },
  //     {
  //       key: '/reports/budget-reports',
  //       labelKey: 'home.budget-reports',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.financialMember,
  //         ],
  //         requiredPermissions: ['BUDGET_REPORT_LIST_READ'],
  //       },
  //     },
  //     {
  //       key: '/operation-admin',
  //       labelKey: 'home.operation-admin',
  //       auth: {
  //         requiredRoles: [ADMIN_ROLES.superAdmin, ADMIN_ROLES.admin],
  //         // requiredPermissions: ['OPERATION_ADMIN_TICKETS_READ'],
  //       },
  //     },
  //     {
  //       key: '/reports/dispute-reports',
  //       labelKey: 'home.dispute-reports',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.operationMember,
  //           ADMIN_ROLES.disputeMember,
  //         ],
  //         requiredPermissions: ['DISPUTE_REPORT_LIST_READ'],
  //       },
  //     },
  //   ],
  // },
  // {
  //   key: 'coins',
  //   icon: Coin,
  //   labelKey: 'home.coins',
  //   children: [
  //     {
  //       key: '/coins/offers',
  //       labelKey: 'home.coins-offers',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.financialMember,
  //         ],
  //         requiredPermissions: ['COINS_PLANS_LIST_READ'],
  //       },
  //     },
  //     {
  //       key: '/coins/services',
  //       labelKey: 'home.coins-Services',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.financialMember,
  //         ],
  //         requiredPermissions: ['COINS_DEDUCTION_LIST_READ'],
  //       },
  //     },
  //     {
  //       key: '/coins/rewards',
  //       labelKey: 'home.coins-rewards',
  //       auth: {
  //         requiredRoles: [
  //           ADMIN_ROLES.superAdmin,
  //           ADMIN_ROLES.admin,
  //           ADMIN_ROLES.financialMember,
  //         ],
  //         requiredPermissions: ['COINS_REWARD_LIST_READ'],
  //       },
  //     },
  //   ],
  // },
  // {
  //   key: 'categories',
  //   icon: Menu,
  //   labelKey: 'home.categoriesAndSkills',
  //   children: [
  //     {
  //       key: '/categories',
  //       labelKey: 'home.allCategories',
  //       auth: {
  //         requiredRoles: [ADMIN_ROLES.superAdmin, ADMIN_ROLES.admin],
  //         requiredPermissions: ['SPECIALITY_OPERATOR_CATEGORY_READ'],
  //       },
  //     },
  //     {
  //       key: '/categories/add',
  //       labelKey: 'home.allCategories',
  //       hiddenInMenu: true,
  //       auth: {
  //         requiredRoles: [ADMIN_ROLES.superAdmin, ADMIN_ROLES.admin],
  //         requiredPermissions: ['SPECIALITY_OPERATOR_CATEGORY_CREATE'],
  //       },
  //     },
  //     {
  //       key: '/categories/skills',
  //       labelKey: 'home.skilsRequests',
  //       auth: {
  //         requiredRoles: [ADMIN_ROLES.superAdmin, ADMIN_ROLES.admin],
  //         requiredPermissions: ['SKILL_OPERATOR_READ'],
  //       },
  //     },
  //   ],
  // },
  // // Quiz
  // {
  //   key: '/quiz',
  //   labelKey: 'home.quiz',
  //   icon: MessageQuestion,
  //   auth: {
  //     requiredRoles: [ADMIN_ROLES.superAdmin, ADMIN_ROLES.admin],
  //     requiredPermissions: ['ADMIN_READ_QUIZZES_LIST'],
  //   },
  // },
  // {
  //   key: '/new-quiz',
  //   labelKey: 'home.newquiz',
  //   hiddenInMenu: true,
  //   auth: {
  //     requiredRoles: [ADMIN_ROLES.superAdmin, ADMIN_ROLES.admin],
  //     requiredPermissions: [
  //       'ADMIN_READ_QUIZ_DETAILS',
  //       'ADMIN_READ_QUIZ_DURATION',
  //       'ADMIN_READ_QUIZ_NUMBER_OF_QUESTIONS',
  //       'ADMIN_UPDATE_QUIZ',
  //       'ADMIN_WRITE_NEW_QUIZ',
  //       'ADMIN_CHECK_QUIZ_EXISTS',
  //     ],
  //   },
  // },

  {
    key: 'reports',
    labelKey: 'home.reports',
    icon: ChartSquare,
    children: [
      {
        key: '/total-revenue',
        icon: MoneyRecive,
        labelKey: 'home.total-revenue',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
          requiredPermissions: ['JOB_FEEDBACK_OPERATOR_READ'],
        },
      },
      {
        key: '/orders-budget',
        icon: Wallet,
        labelKey: 'home.orders-budget',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
          requiredPermissions: ['JOB_FEEDBACK_OPERATOR_READ'],
        },
      },
      {
        key: '/disputes-reports',
        icon: ShieldCross,
        labelKey: 'home.disputes-reports',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
          requiredPermissions: ['JOB_FEEDBACK_OPERATOR_READ'],
        },
      },
      {
        key: '/orders-reports',
        icon: ReceiptItem,
        labelKey: 'home.orders-reports',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
          requiredPermissions: ['JOB_FEEDBACK_OPERATOR_READ'],
        },
      },
      {
        key: '/users-reports',
        icon: People,
        labelKey: 'home.users-reports',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
          requiredPermissions: ['JOB_FEEDBACK_OPERATOR_READ'],
        },
      },
      {
        key: '/subscription-reports',
        icon: Medal,
        labelKey: 'home.subscription-reports',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
          requiredPermissions: ['JOB_FEEDBACK_OPERATOR_READ'],
        },
      },
      {
        key: '/reports/promotions-reports',
        icon: TrendUp,
        labelKey: 'home.promotions-reports',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
        },
      },
    ],
  },

  {
    key: 'admin-configurations',
    labelKey: 'home.admin-configurations',
    icon: Setting2,
    children: [
      {
        key: '/commission',
        icon: PercentageSquare,
        labelKey: 'home.commission-vats',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
          requiredPermissions: ['ADMIN_COMMISSION_CONFIGURATION_READ'],
        },
      },
      {
        key: '/coins/services',
        icon: Coin,
        labelKey: 'home.coins-service-limits',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
          requiredPermissions: ['COINS_DEDUCTION_LIST_READ'],
        },
      },
      {
        key: '/categories',
        icon: Category,
        labelKey: 'home.category-setup',
        auth: {
          requiredRoles: [ADMIN_ROLES.superAdmin, ADMIN_ROLES.admin],
          requiredPermissions: ['SPECIALITY_OPERATOR_CATEGORY_READ'],
        },
      },
      {
        key: '/coins/offers',
        icon: Gift,
        labelKey: 'home.coins-offers',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
          requiredPermissions: ['COINS_PLANS_LIST_READ'],
        },
      },
      {
        key: '/dispute',
        icon: Judge,
        labelKey: 'home.dispute',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.disputeMember,
          ],
          // requiredPermissions: ['JOB_DISPUTE_ES_READ'],
        },
      },
      {
        key: '/promotions-requests',
        icon: Flashy,
        labelKey: 'home.promotions-requests',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
          requiredPermissions: ['ADMIN_COMMISSION_CONFIGURATION_READ'],
        },
      },
      {
        key: '/promotions-slots',
        icon: Notification,
        labelKey: 'home.promotions-slots',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
          requiredPermissions: ['ADMIN_COMMISSION_CONFIGURATION_READ'],
        },
      },
      {
        key: '/promotions-durations/home',
        icon: Home3,
        labelKey: 'home.home-page-promotions',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
          requiredPermissions: ['ADMIN_COMMISSION_CONFIGURATION_READ'],
        },
      },
      {
        key: '/promotions-durations/category',
        icon: Category,
        labelKey: 'home.category-page-promotions',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
          requiredPermissions: ['ADMIN_COMMISSION_CONFIGURATION_READ'],
        },
      },
      {
        key: '/subscriptions-plans',
        icon: Crown,
        labelKey: 'home.subscriptions-plans',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
        },
      },
      {
        key: '/yad-default-promotions',
        icon: Star,
        labelKey: 'home.yad-default-promotions',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
          requiredPermissions: ['ADMIN_COMMISSION_CONFIGURATION_READ'],
        },
      },
    ],
  },

  {
    key: 'job-management',
    labelKey: 'home.jobs-management',
    icon: Briefcase,
    children: [
      {
        key: '/bidding-posts',
        icon: NoteText,
        labelKey: 'home.all-posts',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
        },
      },
      {
        key: '/disliked-jobs',
        icon: Dislike,
        labelKey: 'home.disliked-jobs',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
        },
      },
    ],
  },

  {
    key: 'system-activity-logs',
    labelKey: 'home.system-activity-logs',
    icon: Activity,
    children: [
      {
        key: '/configuration-logs',
        icon: Setting2,
        labelKey: 'home.configuration-logs',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.financialMember,
          ],
        },
      },
      {
        key: '/logistics-feedback',
        icon: Truck,
        labelKey: 'home.logisticsFeedback',
        auth: {
          requiredRoles: [
            ADMIN_ROLES.superAdmin,
            ADMIN_ROLES.admin,
            ADMIN_ROLES.operationMember,
          ],
          requiredPermissions: ['JOB_FEEDBACK_OPERATOR_READ'],
        },
      },
    ],
  },
];

export const getRouteAuthConfig = (
  path: string
): RouteAuthConfig | undefined => {
  const findRoute = (routes: RouteMenuItem[]): RouteMenuItem | undefined => {
    for (const route of routes) {
      if (route.key === path) {
        return route;
      }
      if (route.children) {
        const found = findRoute(route.children);
        if (found) return found;
      }
    }
    return undefined;
  };

  return findRoute(ROUTE_CONFIG)?.auth;
};
